import { createContext, useContext } from 'react';
import { useProcessingNotifications } from '@/hooks/useProcessingNotifications';

const ProcessingNotificationsContext = createContext({
    startPolling: () => { },
    requestPermission: async () => false,
});

export function ProcessingNotificationsProvider({ children }) {
    const notifications = useProcessingNotifications();
    return (
        <ProcessingNotificationsContext.Provider value={notifications}>
            {children}
        </ProcessingNotificationsContext.Provider>
    );
}

export function useProcessingNotificationsContext() {
    return useContext(ProcessingNotificationsContext);
}
